import React from 'react';

const NotFound = () => {
  return <div>NotFound입니다.</div>;
};

export default NotFound;
